import { render } from "./DocumentStatistics.vue?vue&type=template&id=07d91ac0&scoped=true&ts=true"
import script from "./DocumentStatistics.vue?vue&type=script&lang=ts"
export * from "./DocumentStatistics.vue?vue&type=script&lang=ts"

import "./DocumentStatistics.vue?vue&type=style&index=0&id=07d91ac0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07d91ac0"]])

export default __exports__